<template>
    <div class="position-relative" :class="{'position-relative': true, 'pb-5': conclusion}" style="overflow-x: hidden;">
        <div class="chart-container">
            <div class="chart">
                <canvas :id="this.v_id" class="chart-canvas" :height="cvheight"></canvas>
            </div>
            <div v-if="text" class="chart-text d-flex flex-column">
                <br v-if="circumference <= 180"><br v-if="circumference <= 180"><br v-if="circumference <= 180">
                <b data-v-ad11c208="" style="font-size: 2em;">{{ String((chartData[0]/chartData.reduce((partialSum, a) => {return partialSum + a}, 0) * 100).toFixed(2)).replace(/\.(0{1,})$/, "") }}%</b>
                <span>{{ text }}</span>
            </div>
        </div>

        <div class="position-absolute" style="left: 0; right: 0; bottom: 0;">
            <div class="text-center mx-auto"
                :style="'font-size: 1.5em!important, -webkit-user-select: none; -ms-user-select: none; user-select: none;background-color: #fff; color: #000;'">
                <div v-if="conclusion">
                    <h5>
                        <argon-badge :color="conclusion.type ?? 'success'">{{ conclusion.text }}</argon-badge>
                    </h5>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
    .chart-container {
        position: relative;
    }
    .chart-text {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        display: flex;
        justify-content: center;
        align-items: center;
    }
</style>

<script>
import Chart from "chart.js/auto";
import ArgonBadge from './ArgonBadge.vue';

export default {
    components: { ArgonBadge },
    name: "gradient-line-chart",
    props: {
        text: {
            type: String,
            required: false,
        },
        labels: {
            type: Array,
            default: () => {return [];}
        },
        conclusion: {
            type: Object,
            required: false,
        },
        showlegend: {
            type: Boolean,
            default: false,
        },
        chartData: {
            type: Array,
            default: () => {return [0, 0]},
        },
        circumference: {
            type: Number,
            required: false,
        },
        rotation: {
            type: Number,
            required: false,
        },
        cutoutPercentage: {
            type: Number,
            // required: false,
            // default: 100,
            // default: 0,
            default: 77,
        },
        cvheight: {
            type: Number,
            required: false,
        },
        v_id: {
            type: String,
            required: true,
        },
        colors: {
            type: Array,
            default: () => ["#52cb58","#e3f9e6"],
        },
        bgcolor: {
            type: String,
            default: "#52cb58",
        },
        fgcolor: {
            type: String,
            default: "#e3f9e6",
        },
        isShowMaxValue: {
            type: Boolean,
            default: false,
        },
    },
    watch: {
      chartData() {
        this.renderChart();
      },
    },
    mounted() {
      this.renderChart();
    },

    methods: {
      renderChart() {
        const ctx1 = document.getElementById(this.v_id).getContext("2d");

        // check chart existing or not, delete if existing
        const existingChart = Chart.getChart(ctx1);
        if (existingChart) {
          existingChart.destroy();
        }

        if (ctx1) {
            
            const gradientStroke1 = ctx1.createLinearGradient(0, 230, 0, 50);
    
            gradientStroke1.addColorStop(1, "rgba(94, 114, 228, 0.2)");
            gradientStroke1.addColorStop(0.2, "rgba(94, 114, 228, 0.0)");
            gradientStroke1.addColorStop(0, "rgba(94, 114, 228, 0)");
    
            const isShowMaxValue = this.isShowMaxValue;
    
            const chart = new Chart(ctx1, {
                type: "doughnut",
                data: {
                    labels: this.labels,
                    datasets: [
                        {
                            needleValue: 27,
                            tension: 0.4,
                            borderWidth: 0,
                            pointRadius: 0,
                            backgroundColor: this.colors,
                            // eslint-disable-next-line no-dupe-keys
                            fill: true,
                            data: this.chartData,
                            maxBarThickness: 6,
                        },
                    ],
                },
                options: {
                    rotation: this.rotation,
                    circumference: this.circumference,
                    cutout: this.cutoutPercentage,
                    // cutout: 77,
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                        legend: {
                            display: false,
                        },
                    },
                    interaction: {
                        intersect: false,
                        mode: "index",
                    },
                    scales: {
                        y: {
                            grid: {
                                drawBorder: false,
                                display: false,
                                drawOnChartArea: true,
                                drawTicks: false,
                                borderDash: [5, 5],
                            },
                            ticks: {
                                display: false,
                                padding: 10,
                                color: "#fbfbfb",
                                font: {
                                    size: 11,
                                    family: "Open Sans",
                                    style: "normal",
                                    lineHeight: 2,
                                },
                            },
                        },
                        x: {
                            grid: {
                                drawBorder: false,
                                display: false,
                                drawOnChartArea: false,
                                drawTicks: false,
                                borderDash: [5, 5],
                            },
                            ticks: {
                                display: false,
                                color: "#ccc",
                                padding: 20,
                                font: {
                                    size: 11,
                                    family: "Open Sans",
                                    style: "normal",
                                    lineHeight: 2,
                                },
                            },
                        },
                    },
                },
                plugins: [
                    {
                        id: 'text_center',
                        // eslint-disable-next-line no-unused-vars
                        afterDatasetsDraw(chart, args, plugins) {
                            const { ctx, data } = chart;
                            ctx.save();
    
                            if (isShowMaxValue) {
                                const max_data = Math.max(...data.datasets[0].data);
                                const index_max_data = data.datasets[0].data.indexOf(max_data)
                                const label_max_data = data.labels?.[index_max_data] || '-';
        
                                ctx.textAlign = 'center';
                                ctx.font = '24px Open Sans';
                                ctx.fillText(max_data +'%', chart.getDatasetMeta(0).data[0].x, chart.getDatasetMeta(0).data[0].y - 10);
        
                                ctx.textAlign = 'center';
                                ctx.font = '14px Open Sans';
                                ctx.fillText(label_max_data, chart.getDatasetMeta(0).data[0].x, chart.getDatasetMeta(0).data[0].y + 20);
                            }
                        }
                    },
                ],
            });
            return chart;
        }
      }
    },
};
</script>
  